module.exports = {
      id: "icon-a-file-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-a-file",
      toString: function () {
        return this.url;
      }
    }